import type React from 'react'
import { createContext, useState, useContext } from 'react'
import type { Modals } from 'utils/constants'

interface ModalContext {
  openModal: Modals | null
  setOpenModal: (modal: Modals | null) => void
}

export const ModalContext = createContext<ModalContext>({
  openModal: null,
  setOpenModal: () => null,
})

interface ModalProviderProps {
  children: React.ReactNode
}

export const useModalContext = () => useContext(ModalContext)

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [openModal, setOpenModal] = useState<Modals | null>(null)

  return (
    <ModalContext.Provider
      value={{
        openModal,
        setOpenModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}
